import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Sådan tilsluttes slange mellem kulsyre og sodastream
          </Heading1>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="qA1HfO3_2Jg" thumbnail="saadan-tilsluttes-slange-mellem-kulsyre-og-sodastream" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Når du køber slange med tilslutning til kulsyre og sodastream, får du denne pose.
            Man får slangen her. Denne ende er til at sætte på kulsyreflasken.
            Og i denne ende skal man så have ventilen fra en sodasteam-
            kulsyreflaske.
            For at tage ventilen ud af sodastreamkulsyren er det nemmest at bruge
            en skruestik og en svensknøgle.
          </Paragraph>
          <Paragraph>
            Der skal bruge lidt kræfter for at åbne kulsyren.
            Det er bedst hvis flasken er tom inden man skruer den af.
            Den sorte pakning her skal man ikke bruge.
            De tre medfølgende pakninger skal på i stedet for.
          </Paragraph>
          <Paragraph>
            Så sætter du enden, der skal gå til Sodastream, i skruestikken.
            Pakningen fra den gamle sodastreamkulsyre skrues fast.
            Stram herefter godt til med svensknøglen.
          </Paragraph>
          <Paragraph>
            Vi anbefaler at man køber en nøgle til at skrue slangen på kulsyreflasken.
            Test gerne at alt er tæt ved hjælp af en vandtest.
            Åbn for kulsyren og sæt slangen ned i vand. Kommer der ingen bobler er
            slangen tæt.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
